/*
 * Module for the Self Certification And Reciprocity Form
*/
rs.module("content/communications/onlineforms/selfcertificationandreciprocity",

    [

    ],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {
            $.js(jsSelectors.showReciprocitySection1).on("click", function () {
                $.js(jsSelectors.reciprocitySection1).show();
                if ($.js(jsSelectors.showReciprocitySection2).is(":checked")) {
                    $.js(jsSelectors.reciprocitySection2).show();
                    if ($.js(jsSelectors.showReciprocitySection3).is(":checked")) {
                        $.js(jsSelectors.reciprocitySection3).show();
                    }
                }
            });

            $.js(jsSelectors.hideReciprocitySection1).on("click", function () {
                $.js(jsSelectors.reciprocitySection1).hide();
                $.js(jsSelectors.reciprocitySection2).hide();
                $.js(jsSelectors.reciprocitySection3).hide();
            });

            $.js(jsSelectors.showReciprocitySection2).on("click", function () {
                $.js(jsSelectors.reciprocitySection2).show();
                if ($.js(jsSelectors.showReciprocitySection3).is(":checked")) {
                    $.js(jsSelectors.reciprocitySection3).show();
                }
            });

            $.js(jsSelectors.hideReciprocitySection2).on("click", function () {
                $.js(jsSelectors.reciprocitySection2).hide();
                $.js(jsSelectors.reciprocitySection3).hide();
            });

            $.js(jsSelectors.showReciprocitySection3).on("click", function () {
                $.js(jsSelectors.reciprocitySection3).show();
            });

            $.js(jsSelectors.hideReciprocitySection3).on("click", function () {
                $.js(jsSelectors.reciprocitySection3).hide();
            });

            if ($.js(jsSelectors.showReciprocitySection1).is(":checked")) {
                $.js(jsSelectors.reciprocitySection1).show();
                if ($.js(jsSelectors.showReciprocitySection2).is(":checked")) {
                    $.js(jsSelectors.reciprocitySection2).show();
                    if ($.js(jsSelectors.showReciprocitySection3).is(":checked")) {
                        $.js(jsSelectors.reciprocitySection3).show();
                    }
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);